import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AosDirective } from '../../../../shared/directives/aos.directive';
import { ArticleInlineProductComponent } from '../article-inline-product/article-inline-product.component';
import { GameVideoEmbedComponent } from '../../../game-section/components/game-video-embed/game-video-embed.component';
import type { BlogArticleContent } from '../../../../shared/models/blog.model';

@Component({
  selector: 'app-article-body',
  imports: [AosDirective, ArticleInlineProductComponent, GameVideoEmbedComponent],
  templateUrl: './article-body.component.html',
  styleUrl: './article-body.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleBodyComponent {
  content = input.required<BlogArticleContent>();
  accentColor = input<string>('#F59A28');
}
